import qs from 'query-string';
import { querySourceInfo, querySourceInfoByFlag, querySourceInfoByShopId } from "./api";
import { SOURCE_INFO, PROJECT_INFO } from "../utils/keys";
/**
 * 获取公众号信息
 */
export var getSourceInfo = function getSourceInfo() {
  var _sessionStorage;
  // 获取url中的search信息
  var _qs$parse = qs.parse(window.location.search),
    projectId = _qs$parse.projectId,
    collegeId = _qs$parse.collegeId,
    x_field_1 = _qs$parse.x_field_1,
    shopId = _qs$parse.shopId,
    h5id = _qs$parse.h5id;
  // 存储获取source的关键信息
  (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.setItem(PROJECT_INFO, JSON.stringify({
    projectId: projectId,
    collegeId: collegeId,
    x_field_1: x_field_1,
    shopId: shopId,
    h5id: h5id
  }));
  // 是否存在店铺
  if (shopId && shopId !== 'undefined') {
    return getSourceInfoByShopId(Number(shopId));
  }
  // 是否存在标识
  if (x_field_1) {
    return getSourceInfoByXfield(x_field_1);
  }
  return getSourceInfoByProjectIdAndcollegeId(projectId, collegeId);
};

/**
 * 通过xfield获取source
 * @param x_field_1 flag
 */
export var getSourceInfoByXfield = function getSourceInfoByXfield(x_field_1) {
  return new Promise(function (resolve, reject) {
    var _sessionStorage2;
    var sourceInfo = (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.getItem("".concat(SOURCE_INFO, "_xfield_").concat(x_field_1));
    // 如果已经存在
    if (sourceInfo) {
      resolve(JSON.parse(sourceInfo));
    } else {
      querySourceInfoByFlag({
        flag: x_field_1
      }).then(function (data) {
        if (!data.status) {
          var _sessionStorage3;
          (_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.setItem("".concat(SOURCE_INFO, "_xfield_").concat(x_field_1), JSON.stringify(data.result));
          resolve(data.result);
        }
      });
    }
  });
};

/**
 * 通过shopId 获取source
 * @param shopId 店铺id
 */
export var getSourceInfoByShopId = function getSourceInfoByShopId(shopId) {
  return new Promise(function (resolve, reject) {
    var _sessionStorage4;
    var sourceInfo = (_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.getItem("".concat(SOURCE_INFO, "_shopId_").concat(shopId));
    // 如果已经存在
    if (sourceInfo) {
      resolve(JSON.parse(sourceInfo));
    } else {
      querySourceInfoByShopId({
        shopId: shopId
      }).then(function (data) {
        if (!data.status) {
          var _sessionStorage5;
          (_sessionStorage5 = sessionStorage) === null || _sessionStorage5 === void 0 ? void 0 : _sessionStorage5.setItem("".concat(SOURCE_INFO, "_shopId_").concat(shopId), JSON.stringify(data.result));
          resolve(data.result);
        }
      });
    }
  });
};

/**
 * 通过projectId, collegeId 获取source
 * @param projectId 项目id
 * @param collegeId 分校id
 */
export var getSourceInfoByProjectIdAndcollegeId = function getSourceInfoByProjectIdAndcollegeId(projectId, collegeId) {
  return new Promise(function (resolve, reject) {
    var _sessionStorage6;
    var sourceInfo = (_sessionStorage6 = sessionStorage) === null || _sessionStorage6 === void 0 ? void 0 : _sessionStorage6.getItem("".concat(SOURCE_INFO, "_").concat(projectId, "_").concat(collegeId));
    // 如果已经存在
    if (sourceInfo) {
      resolve(JSON.parse(sourceInfo));
    } else {
      querySourceInfo({
        projectId: projectId,
        collegeId: collegeId
      }).then(function (data) {
        if (!data.status) {
          var _sessionStorage7;
          (_sessionStorage7 = sessionStorage) === null || _sessionStorage7 === void 0 ? void 0 : _sessionStorage7.setItem("".concat(SOURCE_INFO, "_").concat(projectId, "_").concat(collegeId), JSON.stringify(data.result));
          resolve(data.result);
        }
      });
    }
  });
};